module.exports = __webpack_public_path__ + "static/national-2-web-regular-be9f267cb707dc83e4db36cb08e2ed4e.eot";